// Single source of truth for site links — change once, applies everywhere.
// Free downloads are static files served from /app/frontend/public/.
// Product URLs are external storefronts (Etsy / Gumroad / Payhip). Use "TBD"
// for any not-yet-set URL — it will fall back to PLACEHOLDER_PRODUCT_URL.

export const PLACEHOLDER_PRODUCT_URL = "https://teachertoolslab.com";

export const FREE_DOWNLOAD_FILES = {
  "rubric-template": "/free-rubric-template.pdf",
  "reflection-sheet": "/student-reflection-sheet.pdf",
  "grading-checklist": "/project-grading-checklist.pdf",
};

export const PRODUCT_URLS = {
  "editable-rubric-bundle": "TBD",
  "classroom-grading-pack": "TBD",
  "project-assessment-templates": "TBD",
  "writing-rubric-pack": "TBD",
  "feedback-sheets": "TBD",
};

export function productUrl(id) {
  const v = PRODUCT_URLS[id];
  return !v || v === "TBD" ? PLACEHOLDER_PRODUCT_URL : v;
}
